import api from '@/lib/axios';

export interface SubscribeNewsletterResponse {
    success: boolean;
    message: string;
}

export const newsletterApi = {
    subscribe: async (email: string): Promise<SubscribeNewsletterResponse> => {
        const response = await api.post<SubscribeNewsletterResponse>('/newsletter/subscribe', {
            email,
        });
        return response.data;
    },
};
